import React from "react";
import {
  CancelOutlined,
  CheckCircle,
  RefreshRounded,
  TimerRounded,
} from "@material-ui/icons";
import { Grid } from "@material-ui/core";
import { MasterButton } from "App/Component/ui";
import { KunjunganRawatJalanCtx } from "../context/context";
import ModalStatusResponse from "pages/BPJS/Vclaim/ui/ModalRequestResponse/ModalStatusResponse";
import { instance2 } from "App/constants";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";

function NomorAntrianJKN({ getAntreanJKN, registrationId }) {
  const stateRajal = React.useContext(KunjunganRawatJalanCtx);
  const [showModalJkn, setShowModalJkn] = React.useState(false);

  const [isLoading, setIsLoading] = React.useState(false);
  const handleClickKirimUlang = async () => {
    try {
      setIsLoading(true);
      const response = await postKirimUlangAntrian(registrationId);
      if (response.data.status === 200 || response.data.status === 201) {
        setIsLoading(false);
        defaultToastSuccess(response.data?.message);
        await getAntreanJKN(registrationId);
      } else {
        setIsLoading(false);
        defaultToastError(response.data?.message);
        await getAntreanJKN(registrationId);
      }
    } catch (error) {
      await getAntreanJKN(registrationId);
      setIsLoading(false);
      defaultToastError(error?.response?.data?.message);
    }
  };

  if (stateRajal?.state?.antrean_jkn?.status === 200) {
    const dataAntrean = stateRajal?.state?.antrean_jkn?.body;
    const statusJkn = dataAntrean?.status_jkn;
    const remark = dataAntrean?.remark_jkn;
    const { getColor, getIcon, getString } = utilityInformasiJkn({
      statusJkn: parseInt(statusJkn),
    });

    return (
      <Grid item xs={12}>
        {showModalJkn && (
          <ModalStatusResponse
            data={dataAntrean.metadata_jkn}
            openStatus={() => setShowModalJkn(false)}
            withButtonDelete
          />
        )}
        <div
          style={{
            backgroundColor:
              statusJkn === 1
                ? "#bbf7d0"
                : statusJkn === 2
                ? "#fecaca"
                : "#fde68a",
            marginLeft: "auto",
            marginRight: "auto",
            padding: "13px 17px",
            borderRadius: "5px",
          }}>
          <div
            style={{
              display: "flex",
              height: "40px",
              justifyContent: "space-between",
            }}>
            <div>
              <p
                style={{
                  fontSize: "11px",
                }}>
                Status Kirim Antrean Online
              </p>
              <p
                style={{
                  color: getColor(true),
                  fontSize: "17px",
                  fontWeight: "500",
                  marginBottom: "12px",
                }}>
                {remark}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "space-between",
              }}>
              <MasterButton
                name={getString(
                  "Terkirim ke JKN",
                  "Gagal Terkirim ke JKN",
                  "Belum diproses"
                )}
                color={getColor(false)}
                type='button'
                onClick={() => {
                  setShowModalJkn(true);
                }}
                size='xs'
                disabled={statusJkn !== 1 && statusJkn !== 2}
                withIcon
                icon={getIcon()}
              />
              <MasterButton
                name='Kirim Ulang'
                color={isLoading ? "secondary" : "lightgreen"}
                onClick={() => handleClickKirimUlang()}
                disabled={isLoading}
                type='button'
                size='xs'
                withIcon
                icon={
                  <RefreshRounded
                    style={{
                      width: "17px",
                    }}
                  />
                }
              />
            </div>
          </div>
        </div>
      </Grid>
    );
  } else {
    return <></>;
  }
}

const postKirimUlangAntrian = (id_kunjungan) => {
  return instance2.post("/registration/antrianjkn/kirim-ulang-antrian-online", {
    id_kunjungan,
  });
};

const utilityInformasiJkn = ({ statusJkn }) => {
  const getString = (strSuccess, strGagal, strPending) => {
    if (statusJkn === 1) {
      //sukses
      return strSuccess;
    } else if (statusJkn === 2) {
      //gagal
      return strGagal;
    } else {
      return strPending; //belum di proses
    }
  };

  const getColor = (isHex) => {
    if (statusJkn === 1) {
      if (isHex) {
        return "#0FB054";
      } else {
        return "lightgreen";
      }
    } else if (statusJkn === 2) {
      if (isHex) {
        return "#CC2B1D";
      } else {
        return "danger";
      }
    } else {
      if (isHex) {
        return "#F09F00";
      } else {
        return "warning";
      }
    }
  };

  const getIcon = () => {
    if (statusJkn === 1) {
      return (
        <CheckCircle
          style={{
            width: "17px",
          }}
        />
      );
    } else if (statusJkn === 2) {
      return (
        <CancelOutlined
          style={{
            width: "17px",
          }}
        />
      );
    } else {
      return (
        <TimerRounded
          style={{
            width: "17px",
          }}
        />
      );
    }
  };

  return {
    getString,
    getColor,
    getIcon,
  };
};

export default NomorAntrianJKN;
